import { render, staticRenderFns } from "./ContractDetailContainer.vue?vue&type=template&id=21d033d8&"
import script from "./ContractDetailContainer.vue?vue&type=script&lang=js&"
export * from "./ContractDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports